import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { ACTIONS, AUDIT_FILTERS, CRM_AUDIT_KINDS, CRM_AUDIT_SORTABLE } from '../vocabulary'
import { entriesQuery, entryQuery } from './queries'

const auditSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_AUDIT_SORTABLE, [], AUDIT_FILTERS, {
    kind: CRM_AUDIT_KINDS,
    action: ACTIONS,
  })

export const auditRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('audit'),
  path: '/audit',
  validateSearch: auditSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(entriesQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'AuditPage'),
})

export const auditEntryRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('audit'),
  path: '/audit/$id',
  validateSearch: auditSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(entryQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'AuditEntryPage'),
})

export const auditRoutes = [auditRoute, auditEntryRoute]
